import React from "react";

const ReleaseNote = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m5.241 15.9 3.961 1.57a21.162 21.162 0 0 0-1.065 3.32l-.15.653 5.678 5.43.683-.14a23.672 23.672 0 0 0 3.472-1.018l1.642 3.786a.254.254 0 0 0 .188.147.264.264 0 0 0 .232-.07l2.482-2.372a3.823 3.823 0 0 0 1.196-2.966l-.089-1.525c4.596-3.244 9.246-8.932 10.513-18.86a1.589 1.589 0 0 0-.48-1.374 1.755 1.755 0 0 0-1.435-.467c-10.384 1.22-16.339 5.67-19.732 10.049l-1.592-.079a4.204 4.204 0 0 0-3.103 1.127l-2.483 2.372a.239.239 0 0 0 .082.418Zm15.925-5.783a3.146 3.146 0 0 1 2.173-.856c.814 0 1.595.31 2.17.861.576.551.9 1.298.9 2.076s-.324 1.525-.9 2.076c-.575.55-1.356.86-2.17.861a3.146 3.146 0 0 1-2.173-.856 2.872 2.872 0 0 1-.904-2.08c0-.782.325-1.53.904-2.082ZM4.5 27.308a4.21 4.21 0 0 0-2.05-.157.378.378 0 0 1-.34-.098.344.344 0 0 1-.076-.4c.728-1.496 2.657-4.501 6.15-2.073a.163.163 0 0 1 .058.124.163.163 0 0 1-.058.124c-.948.714-1.485 1.816-1.444 2.97a.27.27 0 0 0 .266.254c1.201.047 2.354-.455 3.107-1.35a.178.178 0 0 1 .135-.062c.052 0 .102.022.135.061.485.552 1.82 2.353.342 4.093a3.897 3.897 0 0 1-2.575 1.305c-1.434.147-4.084.594-5.166 1.776a.383.383 0 0 1-.362.118.366.366 0 0 1-.28-.249c-.383-1.247-.977-4.034 2.158-6.436Z"
            fill={fill}
        />
    </svg>
);

export default ReleaseNote;